module.exports = __webpack_public_path__ + "img/mouse.de454bfc.png";